import { render, staticRenderFns } from "./Manage-Classes.vue?vue&type=template&id=143de4b4&scoped=true"
import script from "./Manage-Classes.vue?vue&type=script&lang=ts"
export * from "./Manage-Classes.vue?vue&type=script&lang=ts"
import style0 from "./Manage-Classes.vue?vue&type=style&index=0&id=143de4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143de4b4",
  null
  
)

export default component.exports